import { system } from "@smart/bridge-types-basic";
import { buildAssetBucketDef } from "@smart/itops-constructs-basic";
import { buildNamespace } from "@smart/itops-types-basic";

const IntakeFormSnapshotsNS = buildNamespace({
  system,
  entity: "IntakeFormSnapshots",
} as const);

export const IntakeFormSnapshotsDef = buildAssetBucketDef({
  cdn: false,
  prefix: "intakeFormSnapshots",
  namespace: IntakeFormSnapshotsNS,
});
